import "./BurgerMunch.72d14e9a.js";
import "./BurgerMunch.8ee970a6.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3421"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3421"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $2pb0H = parcelRequire("2pb0H");

var $2xpOo = parcelRequire("2xpOo");

var $amjSx = parcelRequire("amjSx");

var $gEdkA = parcelRequire("gEdkA");

var $fczhV = parcelRequire("fczhV");
await (0, $2pb0H.initSite)();
$604ffb2b2899cdf0$var$renderMenuPage();
function $604ffb2b2899cdf0$var$getMenuSections() {
    return (0, $amjSx.getCmsMenu)() ?? (0, $2xpOo.menuSections);
}
function $604ffb2b2899cdf0$var$renderMenuPage() {
    $604ffb2b2899cdf0$var$renderMenu();
    $604ffb2b2899cdf0$var$initMenuNav();
    $604ffb2b2899cdf0$var$initMenuAddButtons();
    $604ffb2b2899cdf0$var$initMenuRemoveButtons();
    $604ffb2b2899cdf0$var$initMenuSectionRemoveButtons();
    (0, $gEdkA.refreshInlineCms)();
}
function $604ffb2b2899cdf0$var$renderMenu() {
    const menuSections = $604ffb2b2899cdf0$var$getMenuSections();
    const root = document.getElementById("menu-root");
    if (!root) return;
    root.innerHTML = menuSections.map((section)=>`
    <section class="bm-menu-section" id="${section.id}" aria-labelledby="title-${section.id}">
      <div class="bm-menu-section__head">
        <h2 class="bm-menu-section__title" id="title-${section.id}" data-cms-menu-section-title="${section.id}">${section.title}</h2>
        ${(0, $amjSx.isAdminAuthed)() ? `<button type="button" class="bm-cms-section-remove" data-cms-menu-section-remove="${section.id}" aria-label="\u{5D4}\u{5E1}\u{5E8} \u{5D0}\u{5EA} ${section.title}">\xd7 \u{5D4}\u{5E1}\u{5E8} \u{5E7}\u{5D8}\u{5D2}\u{5D5}\u{5E8}\u{5D9}\u{5D4}</button>` : ""}
      </div>
      <ul class="bm-menu-grid">
        ${section.items.map((item, index)=>$604ffb2b2899cdf0$var$renderMenuItem(item, section.id, index)).join("")}
      </ul>
      <button type="button" class="bm-cms-menu-add" data-cms-menu-add="${section.id}">+ \u{5D4}\u{5D5}\u{5E1}\u{5E3} \u{5DE}\u{5E0}\u{5D4}</button>
    </section>
  `).join("") + `<div class="bm-menu-cms-actions">
      <button type="button" class="bm-cms-menu-add bm-cms-menu-add--section" data-cms-menu-add-section>+ \u{5D4}\u{5D5}\u{5E1}\u{5E3} \u{5E7}\u{5D8}\u{5D2}\u{5D5}\u{5E8}\u{5D9}\u{5D4}</button>
    </div>`;
}
function $604ffb2b2899cdf0$var$renderMenuItem(item, sectionId, index) {
    const sizes = item.sizes?.trim() ?? "";
    const desc = item.desc?.trim() ?? "";
    const removeBtn = (0, $amjSx.isAdminAuthed)() ? `<button type="button" class="bm-cms-item-remove" data-cms-menu-remove="${sectionId}" data-cms-menu-index="${index}" aria-label="\u{5D4}\u{5E1}\u{5E8} \u{5D0}\u{5EA} ${item.name}">\xd7</button>` : "";
    return `
    <li class="bm-menu-item" data-cms-menu-item data-cms-menu-section="${sectionId}" data-cms-menu-index="${index}">
      ${removeBtn}
      <div class="bm-menu-item__head">
        <div class="bm-menu-item__info">
          <h3 class="bm-menu-item__name" data-cms-menu-field="name">${item.name}</h3>
          <p class="bm-menu-item__sizes${sizes ? "" : " is-empty"}" data-cms-menu-field="sizes">${sizes || (0, $fczhV.MENU_EMPTY_PLACEHOLDERS).sizes}</p>
        </div>
        <p class="bm-menu-item__price" data-cms-menu-field="price">${item.price}</p>
      </div>
      <p class="bm-menu-item__desc${desc ? "" : " is-empty"}" data-cms-menu-field="desc">${desc || (0, $fczhV.MENU_EMPTY_PLACEHOLDERS).desc}</p>
    </li>
  `;
}
function $604ffb2b2899cdf0$var$initMenuRemoveButtons() {
    if (!(0, $amjSx.isAdminAuthed)()) return;
    document.querySelectorAll("[data-cms-menu-remove]").forEach((btn)=>{
        if (btn.dataset.cmsRemoveReady === "1") return;
        btn.dataset.cmsRemoveReady = "1";
        btn.addEventListener("click", (event)=>{
            event.preventDefault();
            event.stopPropagation();
            const sectionId = btn.dataset.cmsMenuRemove;
            const itemIndex = Number(btn.dataset.cmsMenuIndex);
            const name = btn.closest("[data-cms-menu-item]")?.querySelector("[data-cms-menu-field='name']")?.textContent || "\u05D4\u05DE\u05E0\u05D4";
            if (!sectionId || Number.isNaN(itemIndex) || !confirm(`\u{5DC}\u{5D4}\u{5E1}\u{5D9}\u{5E8} \u{5D0}\u{5EA} ${name}?`)) return;
            if (!(0, $amjSx.removeMenuItem)(sectionId, itemIndex)) {
                (0, $gEdkA.showCmsToast)("\u05D7\u05D9\u05D9\u05D1\u05EA \u05DC\u05D4\u05D9\u05E9\u05D0\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA \u05DE\u05E0\u05D4 \u05D0\u05D7\u05EA \u05D1\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4", "error");
                return;
            }
            $604ffb2b2899cdf0$var$renderMenuPage();
            (0, $gEdkA.showCmsToast)("\u05D4\u05DE\u05E0\u05D4 \u05D4\u05D5\u05E1\u05E8\u05D4");
        });
    });
}
function $604ffb2b2899cdf0$var$initMenuSectionRemoveButtons() {
    if (!(0, $amjSx.isAdminAuthed)()) return;
    document.querySelectorAll("[data-cms-menu-section-remove]").forEach((btn)=>{
        if (btn.dataset.cmsRemoveReady === "1") return;
        btn.dataset.cmsRemoveReady = "1";
        btn.addEventListener("click", (event)=>{
            event.preventDefault();
            event.stopPropagation();
            const sectionId = btn.dataset.cmsMenuSectionRemove;
            const title = document.getElementById(`title-${sectionId}`)?.textContent?.trim() || "\u05D4\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4";
            if (!sectionId || !confirm(`\u{5DC}\u{5D4}\u{5E1}\u{5D9}\u{5E8} \u{5D0}\u{5EA} ${title}?`)) return;
            if (!(0, $amjSx.removeMenuSection)(sectionId)) {
                (0, $gEdkA.showCmsToast)("\u05D7\u05D9\u05D9\u05D1\u05EA \u05DC\u05D4\u05D9\u05E9\u05D0\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA \u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4 \u05D0\u05D7\u05EA", "error");
                return;
            }
            $604ffb2b2899cdf0$var$renderMenuPage();
            (0, $gEdkA.showCmsToast)("\u05D4\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4 \u05D4\u05D5\u05E1\u05E8\u05D4");
        });
    });
}
function $604ffb2b2899cdf0$var$initMenuAddButtons() {
    if (!(0, $amjSx.isAdminAuthed)()) return;
    document.querySelectorAll("[data-cms-menu-add], [data-cms-menu-add-section]").forEach((btn)=>{
        if (btn.dataset.cmsAddReady === "1") return;
        btn.dataset.cmsAddReady = "1";
        btn.addEventListener("click", (event)=>{
            event.preventDefault();
            if (btn.hasAttribute("data-cms-menu-add-section")) {
                const sectionId = (0, $amjSx.addMenuSection)();
                if (!sectionId) return;
                $604ffb2b2899cdf0$var$renderMenuPage();
                (0, $gEdkA.showCmsToast)("\u05E0\u05D5\u05E1\u05E4\u05D4 \u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4 \u05D7\u05D3\u05E9\u05D4");
                requestAnimationFrame(()=>{
                    document.getElementById(sectionId)?.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                });
                return;
            }
            const sectionId = btn.dataset.cmsMenuAdd;
            if (!sectionId || !(0, $amjSx.addMenuItem)(sectionId)) return;
            $604ffb2b2899cdf0$var$renderMenuPage();
            (0, $gEdkA.showCmsToast)("\u05E0\u05D5\u05E1\u05E4\u05D4 \u05DE\u05E0\u05D4 \u05D7\u05D3\u05E9\u05D4");
        });
    });
}
function $604ffb2b2899cdf0$var$initMenuNav() {
    const menuSections = $604ffb2b2899cdf0$var$getMenuSections();
    const nav = document.querySelector(".bm-menu-nav");
    if (!nav) return;
    nav.innerHTML = menuSections.map((section)=>`<a class="bm-menu-nav__link" href="#${section.id}">${section.title}</a>`).join("");
    const links = nav.querySelectorAll(".bm-menu-nav__link");
    const sections = menuSections.map((s)=>document.getElementById(s.id)).filter(Boolean);
    const setActive = (id)=>{
        links.forEach((link)=>{
            const active = link.getAttribute("href") === `#${id}`;
            link.classList.toggle("is-active", active);
        });
    };
    if ("IntersectionObserver" in window && sections.length) {
        const observer = new IntersectionObserver((entries)=>{
            const visible = entries.filter((e)=>e.isIntersecting).sort((a, b)=>b.intersectionRatio - a.intersectionRatio)[0];
            if (visible?.target?.id) setActive(visible.target.id);
        }, {
            rootMargin: "-30% 0px -55% 0px",
            threshold: [
                0,
                0.25,
                0.5
            ]
        });
        sections.forEach((section)=>observer.observe(section));
    }
    links.forEach((link)=>{
        link.addEventListener("click", (event)=>{
            const id = link.getAttribute("href")?.slice(1);
            const target = id ? document.getElementById(id) : null;
            if (!target) return;
            event.preventDefault();
            const menuNav = document.querySelector(".bm-menu-nav");
            const menuNavHeight = menuNav?.offsetHeight ?? 0;
            const offset = (0, $2pb0H.getNavOffset)() + menuNavHeight + 16;
            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({
                top: top,
                behavior: "smooth"
            });
            setActive(id);
        });
    });
}


//# sourceMappingURL=menu.6b739860.js.map
